// src/components/BlogPost/BlogPostPage.jsx
import React from "react";
import { useParams } from "react-router-dom";
import { postRoutes } from "../../data/postRoutes";

const BlogPostPage = () => {
  const { slug } = useParams();
  const post = postRoutes.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="text-white p-6 bg-black min-h-screen">
        <h1 className="text-2xl text-red-400">⚠️ Post no encontrado</h1>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white p-6">
      {post.component}
    </div>
  );
};

export default BlogPostPage;
